module.exports = __webpack_public_path__ + "img/basket.7b69c72a.svg";